const config = (
  envVars = process.env,
  isBrowser = !!global.window,
  location = global.window && global.window.location
) => {
  let baseUrl;
  if (isBrowser) {
    const { protocol, hostname, port } = location;
    baseUrl = `${protocol}//${hostname}${port ? `:${port}` : ''}`;
  } else {
    // NOTE: process.env is only available on server-side
    baseUrl = `http://localhost:${envVars.SERVER_PORT}`;
  }

  // generate and return config
  return {
    cacheTTL: envVars.CACHE_TTL,
    correlationIdProp: envVars.CORRELATION_ID_PROP,
    server: {
      port: envVars.SERVER_PORT,
    },
    urls: {
      base: baseUrl,
      topLevelCategories: envVars.CATEGORY_SERVICE,
      individualCategory: envVars.CATEGORY_SERVICE_INDIVIDUAL,
      navigationUrl: envVars.NAVIGATION_SERVICE,
    },
    peepHeader: envVars.FINDABILITY_PEEP_HEADER,
    enableAPICache: envVars.ENABLE_API_CACHE === 'true',
    enableAPICacheCloning: envVars.ENABLE_API_CACHE_CLONING === 'true',
    cacheLimitInBytes: envVars.CACHE_LIMIT_IN_BYTES,
    spaCriteoURL: envVars.SPA_CRITEO_URL,
    spaCriteoEnabled: envVars.SPA_CRITEO_ENABLED === 'true',
    cookieManagementESIEnabled:
      envVars.COOKIE_MANAGEMENT_ESI_ENABLED === 'true',
    chatJlpUrl: envVars.CHAT_JLP_URL,
    chatJlpUrlCustomerService: envVars.CHAT_JLP_URL_CUSTOMER_SERVICE,
    chatUrl: envVars.CHAT_URL,
    chatClientId: envVars.CHAT_CLIENT_ID,
    chatContentUrl: envVars.CHAT_CONTENT_URL,
    chatDeploymentId: envVars.CHAT_DEPLOYMENT_ID,
    chatBaselineAgentUrl: envVars.CHAT_BASELINE_AGENT_URL,
    chatScriptUrl: envVars.CHAT_SCRIPT_URL,
    headerMinibasketActive: envVars.HEADER_MINIBASKET_ACTIVE === 'true',
    authenticationEnabled: envVars.AUTHENTICATION_ENABLED === 'true',
    authenticationBaseUrl: envVars.AUTHENTICATION_BASE_URL,
    accountBaseUrl: envVars.ACCOUNT_BASE_URL,
    enableGzip: envVars.ENABLE_GZIP === 'true',
    monetate: {
      url: envVars.MONETATE_API_URL,
      channel: envVars.MONETATE_CHANNEL,
    },
    hideAemContent: envVars.HIDE_AEM_CONTENT === 'true',
    assetsPath: envVars.ASSETS_PATH,
  };
};

export default config;
